export function clearStreamEnded(stream) {
    if (!stream) return;
    stream.oninactive = null;
    stream.getTracks().forEach(track => { track.onended = null; });
}

export function handleStreamEnded(stream, onEnd) {
    let handled = false;
    stream.oninactive = event => {
        if (handled) return;
        handled = true;
        try {
            onEnd(event);
        } finally {
            clearStreamEnded(stream);
            stream.getTracks().forEach(track => track.stop());
        }
    };
    stream.getTracks().forEach(track => {
        // Usa o handler atual para respeitar a desativação nas trocas e na saída da tela.
        track.onended = event => {
            if (typeof stream.oninactive === 'function') stream.oninactive(event);
        };
    });
}
